export default __webpack_public_path__ + "static/media/Cargar-Factura-Prest-Direct-Honorarios.2e723b54.pdf";